import React from 'react';

const NotImplementedYet = props => {
  return (
    <h1>Not implemented yet!</h1>
  );
}

export default NotImplementedYet;